export default "__VITE_ASSET__BVX5g36k__"